module.exports = __webpack_public_path__ + "static/media/group.bb98aa86.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/group.png
// module id = 781
// module chunks = 0